// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trf-card-info h4[data-v-8b735dde],\n.card-body strong[data-v-8b735dde],\np.card-body[data-v-8b735dde] {\n  font-size: 12px;\n  color: #31708f;\n}\n.trf-card-info h4[data-v-8b735dde] {\n  font-size: 14px;\n}\n.trf-card-info[data-v-8b735dde] {\n  padding: 5px 15px;\n  margin-bottom: 15px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}", ""]);
// Exports
module.exports = exports;
